export {
  REPORT_DONE_TEXT,
  BLOCK_DONE_TEXT,
  REPORT_CHOICE_TEXT,
  REPORT_DETAIL_PLACEHOLDER_TEXT,
  REPORT_REMIND_TEXT,
  REPORT_REMIND_TEXT_COMPANION,
  MOVE_TO_LIST,
  BLOCK_REMIND_TEXT,
  BLOCK_REMIND_TEXT_COMPANION,
  UPLOAD_FILE_SIZE_LIMIT,
  UPLOAD_FILE_OVER_SIZE_MESSAGE,
  UPLOAD_FILE_LENGTH_LIMIT,
  UPLOAD_FILE_LENGTH_LIMIT_MESSAGE,
} from '@myrealtrip/messenger-core';
